export default {
  // START:: SET APP THEME
  setAppTheme(state, payload) {
    state.sakn_w_safar_admin_dashboard_theme = payload;
  },
  // END:: SET APP THEME
};
